import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: 13,
      paddingRight: 13,
      minHeight: `calc(100vh - 79px)`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        minHeight: `100vh`,
      },
    },
    content: {
      marginTop: 70,
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    item: {
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    navigation: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    footer: {
      marginTop: 24,
      marginBottom: 12,
    },
  }),
);

export default useStyles;
